import React from 'react';
import { Form, Upload, Avatar, Select, DatePicker, Input } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Member } from '../../../../services/organizationAPI';

const { Option } = Select;

interface MemberBasicInfoTabProps {
    member: Member | null;
}

export const MemberBasicInfoTab: React.FC<MemberBasicInfoTabProps> = ({ member }) => {
    return (
        <div className="form-section">
            <Form.Item name="avatar" label="头像">
                <Upload
                    name="avatar"
                    listType="picture-card"
                    showUploadList={false}
                    maxCount={1}
                >
                    <Avatar size={100} icon={<UserOutlined />} src={member?.avatar} />
                </Upload>
            </Form.Item>

            <Form.Item name="gender" label="性别">
                <Select placeholder="选择性别">
                    <Option value="male">男</Option>
                    <Option value="female">女</Option>
                    <Option value="other">其他</Option>
                </Select>
            </Form.Item>

            <Form.Item name="birth_date" label="出生日期">
                <DatePicker style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item name="hometown" label="籍贯">
                <Input placeholder="如：广东省深圳市" />
            </Form.Item>

            <Form.Item name="id_number" label="身份证号">
                <Input placeholder="18位身份证号" maxLength={18} />
            </Form.Item>

            <Form.Item name="education" label="学历">
                <Select placeholder="选择学历">
                    <Option value="high_school">高中</Option>
                    <Option value="college">大专</Option>
                    <Option value="bachelor">本科</Option>
                    <Option value="master">硕士</Option>
                    <Option value="doctor">博士</Option>
                </Select>
            </Form.Item>

            <Form.Item name="major" label="专业">
                <Input placeholder="所学专业" />
            </Form.Item>

            <Form.Item name="phone" label="手机号">
                <Input placeholder="手机号码" />
            </Form.Item>

            <Form.Item name="emergency_contact" label="紧急联系人">
                <Input placeholder="紧急联系人姓名" />
            </Form.Item>

            <Form.Item name="emergency_phone" label="紧急联系电话">
                <Input placeholder="紧急联系人电话" />
            </Form.Item>
        </div>
    );
};
